<template>
  <v-row class="fill-height" id="calendar-view">
    <v-col cols="12">
      <v-sheet height="64" class="mt-n3" color="transparent" id="toolbar">
        <v-toolbar v-if="isMobile" flat width="100%">
          <v-btn-toggle v-model="toggle_type" color="primary">
            <v-btn small>
              M/J
            </v-btn>
          </v-btn-toggle>
          <v-btn fab text small color="grey darken-2" @click="prev">
            <v-icon small color="primary">mdi-chevron-left</v-icon>
          </v-btn>
          <v-btn fab text small color="grey darken-2" @click="next">
            <v-icon small color="primary">mdi-chevron-right</v-icon>
          </v-btn>
          <v-spacer></v-spacer>
          <v-toolbar-title
            color="black"
            class="d-flex align-baseline small"
            v-html="smalltitle"
          >
          </v-toolbar-title>
        </v-toolbar>
        <v-toolbar v-else flat width="100%">
          <v-btn-toggle v-model="toggle_type" color="primary">
            <v-btn x-large>
              {{ $t("calendar.day") }}
            </v-btn>
            <v-btn x-large>
              {{ $t("calendar.week") }}
            </v-btn>
            <v-btn x-large>
              {{ $t("calendar.month") }}
            </v-btn>
          </v-btn-toggle>
          <v-spacer></v-spacer>
          <v-toolbar-title
            color="black"
            class="d-flex align-baseline"
            v-html="title"
          >
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn fab text small color="grey darken-2" @click="prev">
            <v-icon small color="primary">mdi-chevron-left</v-icon>
          </v-btn>
          <v-btn outlined color="grey darken-2" @click="setToday">
            {{ $t("calendar.today") }}
          </v-btn>
          <v-btn fab text small color="grey darken-2" @click="next">
            <v-icon small color="primary">mdi-chevron-right</v-icon>
          </v-btn>
          <v-spacer></v-spacer>
        </v-toolbar>
      </v-sheet>
      <v-sheet v-if="isMobilePaysage" height="calc(100% - 100px)">
        <v-calendar
          ref="calendar"
          v-model="value"
          :weekdays="weekdaymob"
          :interval-height="22"
          :event-height="25"
          color="primary"
          :locale="locale"
          :type="types[toggle_type]"
          :interval-style="styleInterval"
          :event-name="eventName"
          :events="allEvents"
          :event-color="getEventColor"
          :short-weekdays="true"
          @change="updateRange"
          :first-interval="7"
          :interval-count="15"
          :interval-format="intervalFormat"
          @click:event="showEvent"
          @click:more="viewDay"
          @click:date="viewWeek"
        ></v-calendar>
        <v-menu
          v-model="selectedOpen"
          :close-on-content-click="false"
          :activator="selectedElement"
          offset-x
        >
          <v-card color="grey lighten-4" min-width="350px" flat>
            <v-toolbar :color="selectedEvent.color" dark>
              <v-btn icon>
                <v-icon>mdi-calendar</v-icon>
              </v-btn>
              <v-toolbar-title v-html="selectedEvent.name"></v-toolbar-title>
              <v-spacer></v-spacer>
            </v-toolbar>
            <v-card-text>
              <span v-html="selectedEvent.details"></span>
            </v-card-text>
            <v-card-actions>
              <v-btn text color="secondary" @click="selectedOpen = false">
                Fermer
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-menu>
      </v-sheet>
      <v-sheet v-else height="calc(100% - 64px)">
        <v-calendar
          ref="calendar"
          v-model="value"
          :weekdays="weekday"
          :interval-height="48"
          :event-height="25"
          color="primary"
          :locale="locale"
          :type="types[toggle_type]"
          :interval-style="styleInterval"
          :event-name="eventName"
          :events="allEvents"
          :event-color="getEventColor"
          :short-weekdays="false"
          @change="updateRange"
          :first-interval="7"
          :interval-count="15"
          :interval-format="intervalFormat"
          @click:event="showEvent"
          @click:more="viewDay"
          @click:date="viewWeek"
        ></v-calendar>
        <v-menu
          v-model="selectedOpen"
          :close-on-content-click="false"
          :activator="selectedElement"
          offset-x
        >
          <v-card color="grey lighten-4" min-width="350px" flat>
            <v-toolbar :color="selectedEvent.color" dark>
              <v-btn icon>
                <v-icon>mdi-calendar</v-icon>
              </v-btn>
              <v-toolbar-title v-html="selectedEvent.name"></v-toolbar-title>
              <v-spacer></v-spacer>
            </v-toolbar>
            <v-card-text>
              <span v-html="selectedEvent.details"></span>
            </v-card-text>
            <v-card-actions>
              <v-btn text color="secondary" @click="selectedOpen = false">
                Fermer
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-menu>
      </v-sheet>
    </v-col>
  </v-row>
</template>

<script>
import TICKET_API from "../api/ticket";
import moment from "../plugins/moment";
import { capitalize, escapeHTML, shouldDisplay } from "../utils";
import { mapGetters } from "vuex";
import { convert } from "../utils/icsToJson";
import { EventBus } from "../event-bus";

export default {
  name: "Calendar",
  data: () => ({
    toggle_type: 2,
    types: ["day", "week", "month"],
    reservations: [],
    reservationItems: [],
    value: "",
    start: null,
    today: moment().format(),
    end: null,
    weekday: [1, 2, 3, 4, 5, 6, 0],
    weekdaymob: [1, 2, 3, 4, 5],
    events: [],
    icsEvents: [],
    colors: [
      "blue",
      "indigo",
      "deep-purple",
      "cyan",
      "green",
      "orange",
      "deep-orange",
      "red lighten-1",
      "purple darken-1",
      "pink darken-1",
      "red accent-3",
      "deep-purple lighten-4",
      "indigo darken-1",
      "blue darken-4"
    ],
    icsColors: [
      "blue-grey darken-3",
      "grey darken-4",
      "grey darken-1",
      "grey darken-2",
      "grey",
      "blue-grey lighten-4",
      "blue-grey lighten-3",
      "blue-grey lighten-2",
      "blue-grey lighten-1",
      "grey darken-3"
    ],
    icsCalendarUid: [],
    selectedEvent: {},
    selectedElement: null,
    selectedOpen: false
  }),
  methods: {
    prev() {
      this.$refs.calendar.prev();
    },
    next() {
      this.$refs.calendar.next();
    },
    getEventColor(event) {
      return event.color;
    },
    formatDate(a, withTime = true) {
      return withTime
        ? `${a.getFullYear()}-${a.getMonth() +
            1}-${a.getDate()} ${a.getHours()}:${a.getMinutes()}`
        : `${a.getFullYear()}-${a.getMonth() + 1}-${a.getDate()}`;
    },
    loadData() {
      this.reservations = [];
      this.reservationItems = [];
      this.events = [];
      TICKET_API.getReservationItems().then(({ data }) => {
        const totalColors = this.colors.length;
        let reservationItems = data;
        TICKET_API.getReservations().then(({ data }) => {
          reservationItems.forEach(async (item, i) => {
            let reservations = data.filter(
              el => el.reservationitems_id === item.id
            );
            const {
              data: { name }
            } = await TICKET_API.getReservationItem(
              item.itemtype,
              item.items_id
            );
            reservations.forEach(res => {
              if (shouldDisplay(res)) {
                this.events.push({
                  name: `${name} - ${res.comment}`,
                  start: moment(res.begin).format("YYYY-MM-DD HH:mm:ss"),
                  end: moment(res.end).format("YYYY-MM-DD HH:mm:ss"),
                  color: this.colors[i % totalColors]
                });
              }
            });
            this.$refs.calendar.checkChange();
            this.reservations = this.reservations.concat(reservations);
          });
        });
      });
    },
    updateRange({ start, end }) {
      this.start = start;
      this.end = end;
    },
    styleInterval() {
      return {
        display: "flex",
        "flex-wrap": "wrap"
      };
    },
    eventName(event, timedEvent) {
      const name = escapeHTML(event.input["name"]);
      if (event.start.hasTime) {
        if (timedEvent) {
          const showStart = event.start.hour < 24 && event.end.hour >= 24;
          const start = this.formatTime(event.start, showStart);
          const end = this.formatTime(event.end, true);
          return `<strong>${name}</strong><br>${start} - ${end}`;
        } else {
          const time = this.formatTime(event.start, true);
          return `<strong class="mr-1">${time}</strong> ${name}`;
        }
      }
      return name;
    },
    intervalFormat(timestamp, short) {
      const suffix = short ? "h " : "";
      return `${timestamp.hour} ${suffix}`;
    },
    formatTime(withTime, ampm) {
      const suffix = ampm ? "h " : "";
      const hour = withTime.hour % 24 || 0;
      const minute = withTime.minute;

      return minute > 0
        ? minute < 10
          ? `${hour}:0${minute}${suffix}`
          : `${hour}:${minute}${suffix}`
        : `${hour}${suffix}`;
    },
    loadCalendar() {
      this.icsEvents = [];
      this.icsCalendarUid = [];
      this.calendarUrl.forEach(url => {
        fetch(url, {
          headers: {
            "Content-Type": "text/calendar; charset=utf-8"
          }
        })
          .then(response => {
            return response.text();
          })
          .then(data => {
            let icsCalendar = convert(data);

            if (icsCalendar && icsCalendar.VCALENDAR) {
              const calendar = icsCalendar.VCALENDAR[0];
              const totalColors = this.icsColors.length;
              calendar.VEVENT &&
                calendar.VEVENT.forEach(res => {
                  if (!this.icsCalendarUid.includes(res.UID))
                    this.icsCalendarUid.push(res.UID);
                  this.icsEvents.push({
                    name: res.DESCRIPTION,
                    start: moment(res.DTSTART).format("YYYY-MM-DD HH:mm:ss"),
                    end: moment(res.DTEND).format("YYYY-MM-DD HH:mm:ss"),
                    color: this.icsColors[
                      this.getIcsColor(res.UID) % totalColors
                    ]
                  });
                });
            }
          });
      });
    },
    getIcsColor(Uid) {
      return this.icsCalendarUid.findIndex(c => c === Uid);
    },
    viewDay({ date }) {
      this.toggle_type = 0;
      this.value = date;
    },
    viewWeek({ date }) {
      this.toggle_type = 1;
      this.value = date;
    },
    showEvent({ nativeEvent, event }) {
      const open = () => {
        this.selectedEvent = event;
        this.selectedElement = nativeEvent.target;
        setTimeout(() => (this.selectedOpen = true), 10);
      };

      if (this.selectedOpen) {
        this.selectedOpen = false;
        setTimeout(open, 10);
      } else {
        open();
      }

      nativeEvent.stopPropagation();
    },
    setToday() {
      this.value = "";
    }
  },
  mounted() {
    if (this.getUserProfileStatus) {
      this.loadData();
    }

    if (this.getPersonalToken) {
      this.loadCalendar();
    }

    EventBus.$on("calendar", data => {
      if (data.direction === "next") {
        this.next();
      } else {
        this.prev();
      }
    });
  },
  computed: {
    ...mapGetters([
      "getUserId",
      "getGLPGroup",
      "getPersonalToken",
      "getSessionToken",
      "getUUID",
      "getUserProfileStatus"
    ]),
    locale() {
      return this.$root.$i18n.locale;
    },
    calendarUrl() {
      //return `https://portail.pilote.immo/glpi/front/planning.php/?genical=1&uID=${this.getUserId}&gID=0&entities_id=${this.$route.params.id}&is_recursive=0&token=${this.getPersonalToken}`;
      return [
        `https://pitrack.pilote.immo/pitrack/front/planning.php/?genical=1&uID=${this.getUserId}&gID=0&entities_id=${this.$route.params.id}&is_recursive=0&token=${this.getPersonalToken}`,
        `https://pitrack.pilote.immo/pitrack/front/planning.php/?genical=1&uID=0&gID=${this.getGLPGroup}&entities_id=${this.$route.params.id}&is_recursive=0&token=${this.getPersonalToken}`
      ];
    },
    title() {
      const { start, end } = this;
      if (!start || !end) {
        return "";
      }

      const date = moment(start.date)
        .locale(this.locale)
        .format("MMMM YYYY");
      const week = moment(start.date)
        .locale(this.locale)
        .week();

      let title = `<h2>${capitalize(date)}</h2>`;

      return this.toggle_type === 2
        ? title
        : `${title}/ <span style="color: red">Semaine ${week}</span>`;
    },
    smalltitle() {
      const { start, end } = this;
      if (!start || !end) {
        return "";
      }

      const date = moment(start.date)
        .locale(this.locale)
        .format("MM/YY");
      const week = moment(start.date)
        .locale(this.locale)
        .week();

      let smalltitle = `<h4>${capitalize(date)}</h4>`;

      return this.toggle_type === 2
        ? smalltitle
        : `${smalltitle} <h5 style="color: red"> S${week}</h5>`;
    },
    allEvents() {
      return this.events.concat(this.icsEvents).map(event => {
        let start = moment(event.start).format("DD MMMM YYYY à HH:mm:ss");
        let end = moment(event.end).format("DD MMMM YYYY à HH:mm:ss");
        const details = `<table class="event--table"><tr><td>Debut:</td> <td>${start}</td></tr><tr><td>Fin:</td><td>${end}</td></tr></table>`;
        event.details = details;
        return event;
      });
    },
    isMobile() {
      return (
        this.$vuetify.breakpoint.width < this.$vuetify.breakpoint.thresholds.md
      );
    },
    isMobilePaysage() {
      return (
        this.$vuetify.breakpoint.width <
          this.$vuetify.breakpoint.thresholds.lg &&
        this.$vuetify.breakpoint.height > this.$vuetify.breakpoint.width
      );
    }
  },
  watch: {
    getUserProfileStatus() {
      if (this.getUserProfileStatus) {
        this.loadData();
      }
    },
    getPersonalToken() {
      if (this.getPersonalToken) {
        this.loadCalendar();
      }
    },
    getGLPGroup() {
      this.$nextTick(() => {
        if (this.getUserProfileStatus) {
          this.loadData();
        }

        if (this.getPersonalToken) {
          this.loadCalendar();
        }
      });
    }
  }
};
</script>

<style>
.pl-1 {
  font-size: 0.9rem;
}
#calendar-view {
  position: absolute;
  top: 0;
  min-height: 100vh;
  width: 100%;
}
#calendar-view #toolbar header {
  background-color: transparent;
  position: relative;
  z-index: 3;
}
.v-calendar-weekly__head {
  height: 50px;
  padding-top: 5px;
  background-color: #f7f7f7;
}
.v-calendar-weekly__head-weekday {
  display: flex;
  align-items: center;
  justify-content: center;
}
.event--table th,
.event--table td {
  padding: 15px;
  text-align: left;
}
</style>
